import { defaultTo } from "ramda";
import React from "react";
import { Icons } from "../../icons";

export type IconsList = keyof typeof Icons;

export const Icon = ({
  icon,
  size = 2,
  className = "",
  unit = "em",
  style = {},
}: {
  icon: IconsList;
  size?: number;
  unit?: "em" | "rem" | "%" | "px" | "";
  className?: string;
  style?: React.CSSProperties;
}) => {
  const Renderer = defaultTo(Icons.empty, Icons[icon]);

  let width = size;
  let height = size;

  return (
    <Renderer
      className={className}
      style={{ width: width + unit, height: height + unit, ...style }}
    />
  );
};
